import { Injectable } from '@angular/core';
import {Menu} from "../model/Menu";
import {Http, Response} from "@angular/http";
import { Headers, RequestOptions } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {AuthenticationService} from "./authentication.service";
import {environment} from "../../environments/environment";

@Injectable()
export class MenuService {

    menuUrl = environment.instantPaiementApi + "menus";

    constructor(private http: Http,
                private authenticationService: AuthenticationService) {}


    getMenu(id: number): Promise<Menu> {
        return this.http.get(this.menuUrl + "/" + id)
            .toPromise()
            .then(response => response.json() as Menu)
            .then(undefined, (error) => { console.error(error.code); })
            .catch(this.handleError);
        //return Promise.resolve(this.menu);
    }

    getListMenus(): Promise<Menu[]> {
        return this.http.get(this.menuUrl)
            .toPromise()
            .then(response => response.json() as Menu[])
            .then(undefined, (error) => { console.error(error); })
            .catch(this.handleError);
    }

    addMenu(menu:Menu): Promise<Menu> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.menuUrl, menu, options).toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    modifyMenu(menu:Menu): Promise<Menu> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.put(this.menuUrl + "/" + menu.id, menu, options).toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || { };
    }

    handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/services/menu.service.ts